import React, { Component, } from 'react';
import { Card, Button, CardTitle, CardText, CardImg } from 'reactstrap';
import '../css/styles.css';
import HTML from '../image/html5.png';
import CSS from '../image/css.png';
import ANDROID from '../image/android.png';
import JAVA from '../image/java.png';
import MYSQL from '../image/mysql.png';
import NODE from '../image/nodejs.png';
import PYTHON from '../image/python.png';
import REACT from '../image/react.png';
import WORDPRESS from '../image/wordpress.png';
import 'bootstrap/dist/css/bootstrap.min.css';
function Skill(){

    return(
        
        <div className="container mt-4 mb-4      "  >
            <h4 className="about">Skills</h4>
            <div className="row" >
                <div className="col-6 ">
                <p><span><img class="icon" src={HTML}/><img class="icon" src={CSS}/>   HTML & CSS</span></p>
                
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={HTML}/>   Javascript</span></p>
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={ANDROID}/>   Android Dev.</span></p>
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={PYTHON}/>   Python</span></p>
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={REACT}/>   React</span></p>
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={HTML}/>   Django</span></p>
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={WORDPRESS}/>Wordpress</span></p>
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={NODE}/>   NodeJs</span></p>
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={MYSQL}/>   MySql</span></p>
                </div>
                <div className="col-6">
                <p><span><img class="icon" src={JAVA}/>   Java</span></p>
                </div>
            </div>
        </div>
    )

}

export default Skill;